// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const VideoPauseButton: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#eee", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 36 38" width={width} height={height}>
            <g fill="none" fillRule="evenodd">
                <ellipse cx="18" cy="19" fill={color1} opacity=".8" rx="18" ry="19" />
                <path
                    fill={color1}
                    fillRule="nonzero"
                    d="M18 0c9.941 0 18 8.507 18 19s-8.059 19-18 19S0 29.493 0 19 8.059 0 18 0m0 .5C8.341.5.5 8.777.5 19S8.341 37.5 18 37.5 35.5 29.223 35.5 19 27.659.5 18 .5"
                />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M14.5 14c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5H16c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm-1.5.5a1.5 1.5 0 0 1 1.5-1.5H16a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 16 25h-1.5a1.5 1.5 0 0 1-1.5-1.5zm7-.5c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h1.5c.275 0 .5-.225.5-.5v-9c0-.275-.225-.5-.5-.5zm-1.5.5A1.5 1.5 0 0 1 20 13h1.5a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H20a1.5 1.5 0 0 1-1.5-1.5z"
                />
            </g>
        </svg>
    );
};

export default React.memo(VideoPauseButton);
